import { byType } from 'rxOperators/byType'
import { EpicRefined } from 'interfaces/middleware'
import { OpenSellCryptoPaneAction, RewardsPaneActions } from 'components/features/rewards/rewardsPane/store/actions/paneState'
import { merge } from 'lodash'
import { mergeMap } from 'rxjs/operators'
import { ModifyFloatingPaneAction } from 'actions/floatingPanesActions'
import { of } from 'rxjs'
import { cryptoWalletNotEmptyTickerSelector } from 'components/features/rewards/rewardsPane/store/selectors/cryptoWallet'


export const openSellCryptoEpic: EpicRefined<RewardsPaneActions> = (action$, store) => {

  return merge(
    action$.pipe(
      byType(OpenSellCryptoPaneAction.type),
      mergeMap(() => {
        const state = store.getState()
        const wallet = cryptoWalletNotEmptyTickerSelector(state)
        const count = wallet?.length ?? 0

        if (count === 0) {
          return of(new ModifyFloatingPaneAction({
            type: 'cryptoRewards',
            mode: 'cryptoRewardsSellMode',
            step: 'CRYPTO_REWARDS_SELL_MODE_STEP_LOADING',
            progressPercents: 10,
          }))
        }

        if (count === 1) {
          return of(new ModifyFloatingPaneAction({
            type: 'cryptoRewards',
            mode: 'cryptoRewardsSellMode',
            step: 'CRYPTO_REWARDS_SELL_MODE_STEP_SELL_AMOUNT',
            progressPercents: 20,
            fields: {
              cryptoCurrencyIDChosenForSelling: wallet[0],
            },
          }))
        }

        return of(new ModifyFloatingPaneAction({
          type: 'cryptoRewards',
          mode: 'cryptoRewardsSellMode',
          step: 'CRYPTO_REWARDS_SELL_MODE_STEP_CRYPTO_WALLET',
          progressPercents: 20,
        }))
      }),
    )
  )
}
